<div class="modal-choose-country">
  <div *ngIf="isLoading" class="modal-choose-country__loader">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <div class="modal-choose-country__title">
    <h2>{{ 'MODAL_CHOOSE_COUNTRY.TITLE' | i18nextEager }}</h2>
  </div>
  <span class="modal-choose-country__text">{{ 'MODAL_CHOOSE_COUNTRY.TEXT' | i18nextEager }}</span>
  <form class="modal-choose-country__form" [formGroup]="chooseCountryForm">
    <mat-radio-group class="modal-choose-country__radios" aria-labelledby="" formControlName="country" ngDefaultControl required>
      <mat-radio-button [value]="'ES'">
        <span class="wrap-mat-radio-label">{{ 'MODAL_CHOOSE_COUNTRY.SPAIN' | i18nextEager }}</span>
      </mat-radio-button>
      <mat-radio-button [value]="'PT'">
        <span class="wrap-mat-radio-label">{{ 'MODAL_CHOOSE_COUNTRY.PORTUGAL' | i18nextEager }}</span>
      </mat-radio-button>
    </mat-radio-group>
    <div class="modal-choose-country__enter">
      <button [disabled]="chooseCountryForm.invalid" (click)="enter()">
        {{ 'MODAL_CHOOSE_COUNTRY.ENTER' | i18nextEager }}
      </button>
    </div>
  </form>
</div>
